import { hasRouteValue } from "@/Composables/useRouteSupport";
import {
  BookOpenIcon,
  CalendarIcon,
  ChartBarIcon,
  CurrencyDollarIcon,
  HomeIcon,
  PaperAirplaneIcon,
  RectangleStackIcon,
  UserGroupIcon,
} from "@heroicons/vue/24/outline";
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

export default function vendorNavigation() {
  const page = usePage();
  const user = computed(() => page.props?.auth?.user);
  const summitEventId = computed(() => page.props?.summit?.id ?? null);

  const navigation = [
    { name: "Dashboard", route: "dashboard.index", icon: HomeIcon, component: "Vendor/Dashboard" },
    {
      name: "Program Maintenance",
      subName: "(Blue Book)",
      route: "blue-book-platform.supplier.show",
      icon: BookOpenIcon,
      params: { supplier: user.value.company_id },
    },
    // {
    //   name: "Central Billing Form",
    //   route: "central-billing.index",
    //   icon: BookOpenIcon,
    //   params: { supplier: user.value.company_id },
    // },
    {
      name: "Calendar of Events",
      route: "upcoming-events.index",
      component: "UpcomingEvents/Index",
      icon: CalendarIcon,
    },
    // ! Suppliers do not get access to the Blue Book Platform
    {
      name: "Contacts",
      icon: UserGroupIcon,
      children: [
        {
          name: "MSD Board Members",
          route: "contacts.msd-board-members.index",
          component: "Contacts/MsdBoardMembers",
        },
        {
          name: "MSD Contacts",
          route: "contacts.msd-contacts.index",
          component: "Contacts/MsdContacts",
        },
        {
          name: "Member Companies",
          route: "contacts.member-companies.index",
          component: "Contacts/MemberCompanies",
        },
        // { name: "Suppliers", route: "contacts.suppliers.index", component: "Contacts/Suppliers" },
        // { name: "Rep Groups", route: "contacts.reps.index", component: "Contacts/Reps" },
        {
          name: "My Company Profile/Contacts",
          route: "company-profile.index",
          component: "CompanyProfile.Index",
        },
        {
          name: "Buyers",
          route: "contacts.buyers.index",
          component: "Contacts/Buyers",
        },
      ],
    },
    { name: "Committees", route: "committees.index", icon: RectangleStackIcon, component: "Committees/Index" },
    // { name: "Warehouse", route: "warehouse.index", icon: TruckIcon, component: "Warehouse/Index" },
    // {
    //   name: "Events Calendar",
    //   route: "events.calendar.index",
    //   icon: CalendarIcon,
    //   component: "Events/Calendar/Index",
    // },
    // { name: "Analytics", route: "vendor.analytics.index", icon: ChartBarIcon, component: "Vendor/Analytics" },
    // { name: "Files", route: "vendor.files.index", icon: FolderIcon, component: "Vendor/Files" },
    // { name: "Videos", route: "vendor.videos.index", icon: VideoCameraIcon, component: "Vendor/Videos" },
    // { name: "Messages", action: () => state.toggleMessages(true), icon: ChatBubbleBottomCenterTextIcon },

    {
      name: "Shows",
      icon: CurrencyDollarIcon,
      children: [
        {
          name: "Upcoming/Next Shows",
          route: "events.next-shows.index",
          component: "Events/NextShows/Index",
        },
        {
          name: "Archived Shows",
          route: "events.archived-shows.index",
          component: "Events/ArchivedShows/Index",
        },
        ...(hasRouteValue(summitEventId.value)
          ? [
              {
                name: "Summit Registration",
                route: "events.event.summit.registration",
                params: { event: summitEventId.value, company_id: user.value?.company_id },
                component: "Events/Summit/Registration",
              },
            ]
          : []),
      ],
    },

    // {
    //   name: "Events",
    //   icon: CalendarIcon,
    //   children: [
    //     { name: "Event Calendar", route: "upcoming-events.index", component: "UpcomingEvents/Index" },
    //     // {
    //     //   name: "Events Calendar",
    //     //   route: "events.calendar.index",
    //     //   component: "Events/Calendar/Index",
    //     // },
    //     { name: "Virtual Shows", route: "events.index", component: "Events" },
    //     // {
    //     //   name: "Virtual Shows - Archived",
    //     //   route: "events.archived.index",
    //     //   component: "Events/Archived/Index",
    //     // },
    //   ],
    // },
    { name: "Reports", route: "stationary-reports.index", icon: ChartBarIcon, component: "Reports/Index" },
    { name: "Travel Requests", route: "travel.requests.index", icon: PaperAirplaneIcon, component: "Travel/Requests/Index" },
  ];

  return {
    navigation,
  };
}
